import { SectionCard } from '../yeni-design/primitives';
import { ZararDetay } from './detay/ZararDetay';
import type { DetayGovdeProps } from './detay/detayTipleri';

/** Karlilik sekmesi: uyari penceresindeki zararina satis listesinin aynisi, satirdan urun detayi acilir. */
export function ZararBlok(p: DetayGovdeProps) {
  if (!p.kaynaklar.zararinaSatis) return null;
  return (
    <div data-testid="blok-zarar">
      <SectionCard
        title="Zararına satılan ürünler"
        subtitle="Maliyetin altında satılanlar · kart maliyeti"
        bodyClass="p-5 max-h-[460px] overflow-y-auto"
      >
        <ZararDetay {...p} />
      </SectionCard>
    </div>
  );
}
